import NoEncryptionIcon from '@mui/icons-material/NoEncryption';
import SavingsIcon from '@mui/icons-material/Savings';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import JpgResponseCodeDrawerButton from 'project/utils/inputs/JpgResponseCodeDrawerButton';
import JpgResponseCodeInput from 'project/utils/inputs/JpgResponseCodeInput';
import { AutoCompleteInput, BooleanField, BooleanInput, Button, Create, CreateButton, Datagrid, Edit, EditButton, ExportButton, FilterButton, FormDataConsumer, FormTab, List, NumberField, NumberInput, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, TopToolbar, useDataProvider, useListContext, usePermissions, useResourceContext, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import Donation from 'utils/GeneratedModels/Donation';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import NumberRangeFilterInput from 'utils/react-admin/filters/NumberRangeFilterInput';
import NullableBitInput from 'utils/react-admin/inputs/NullableBitInput';
import { Permissions } from '../../ra-php-crud-api-auth';
import { _makeFilter } from 'ra-data-treeql';
import { BASE_URL } from 'utils/api';
import fetchJson from 'utils/fetchJson';

export const CHOICES_DONATION_TYPE = [
  { id: 'plan', name: 'plan 「萬眾一心 真愛同行」計劃捐款', },
  { id: 'general', name: 'general 一般捐款', },
  { id: 'scs', name: 'scs 為「心安處・靈性關懷中心」籌款', },
  { id: 'bcu', name: 'bcu 佛教院侍', },
];

export const CHOICES_DONATION_PERSONAL_TEAM = [
  { id: '', name: 'empty 空白', },
  { id: '1', name: 'personal 個人捐款', },
  { id: '2', name: 'organization 團體捐款', },
];

export const CHOICES_DONATION_SALUTARION = [
  { id: 'mr', name: 'mr', },
  { id: 'ms', name: 'ms', },
];

export const CHOICES_DONATION_PAYMENT_METHOD = [
  { id: 'cash', name: 'cash', },
  { id: 'cheque', name: 'cheque', },
  { id: 'back_transfer', name: 'back_transfer', },
  { id: 'credit_card', name: 'credit_card', },
  { id: 'monthly', name: 'Monthly', },
  { id: 'once', name: 'Once', },
];

// export const CHOICES_DONATION_CREDIT_CARD = [
//   { id: 'visa', name: 'visa', },
//   { id: 'master', name: 'master', },
// ];

export const CHOICES_DONATION_PLAN_PURPOSE = [
  { "id": "1", "name": "沉香西方三聖" },
  { "id": "2", "name": "琉璃藥師如來" },
  { "id": "3", "name": "自置會址及擴展會務" },
  // { "id": "4", "name": "中心新址裝修費" },
  // { "id": "5", "name": "中心新址新設備" },
  // { "id": "6", "name": "中心新頁新貌" },
  { "id": "7", "name": "中心營運經費" }
];

export const CHOICES_DONATION_GENERAL_METHOD = [
  { id: 'monthly', name: 'monthly', },
  { id: 'single', name: 'single', },
];

export const CHOICES_DONATION_GENERAL_STATUS = [
  { id: 'start', name: 'Start', },
  { id: 'error', name: 'Error', },
  { id: 'succeed', name: 'Succeed', },
  { id: 'cancelled', name: 'Cancelled', },
];

export const CHOICES_DONATION_GENERAL_PURPOSE = [
  { "id": "1", "name": "中心營運經費" },
  { "id": "2", "name": "佛教院侍服務" },
  { "id": "3", "name": "安老服務" },
  { "id": "4", "name": "福行關愛基金" },
  { "id": "5", "name": "印經" },
  { "id": "6", "name": "法會" },
  { "id": "7", "name": "禪修" },
  { "id": "8", "name": "一般捐款" },
  { "id": "9", "name": "其他" },
  { "id": "10", "name": "中心會址" },
  { "id": "11", "name": "安老院服務" },
  { "id": "12", "name": "心安處‧靈性關懷中心" },
];

export const CHOICES_DONATION_GENERAL_PURPOSE_2 = [
  { "id": "1", "name": "自置會址及擴展會務" },
  { "id": "2", "name": "佛教院待服務" },
  { "id": "3", "name": "一般捐款" },
  { "id": "others", "name": "其他" }
];

export const CHOICES_DONATION_RECEIPT_METHOD = [
  { id: '1', name: '中心取', },
  { id: '2', name: '郵寄', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <SelectInput source="type" alwaysOn fullWidth choices={CHOICES_DONATION_TYPE} />,
  <TextInput source="invoice_number" fullWidth />,
  <TextInput source="jpg_invoice_number" fullWidth />,
  <SelectInput source="status" fullWidth choices={CHOICES_DONATION_GENERAL_STATUS} />,
  <NumberRangeFilterInput source="monthly_amount" fullWidth />,
  <NumberRangeFilterInput source="amount" fullWidth />,
  <SelectInput source="personal_team" fullWidth choices={CHOICES_DONATION_PERSONAL_TEAM} />,
  <TextInput source="name" fullWidth />,
  <TextInput source="contact_person" fullWidth />,
  <SelectInput source="salutarion" fullWidth choices={CHOICES_DONATION_SALUTARION} />,
  <TextInput source="contact_person_tel" fullWidth />,
  <TextInput source="email" fullWidth />,
  <TextInput source="address" fullWidth />,
  <SelectInput source="payment_method" fullWidth choices={CHOICES_DONATION_PAYMENT_METHOD} />,
  <TextInput source="credit_card" fullWidth />,
  <SelectInput source="plan_purpose" fullWidth choices={CHOICES_DONATION_PLAN_PURPOSE} />,
  // <SelectInput source="general_method" fullWidth choices={CHOICES_DONATION_GENERAL_METHOD} />,
  <SelectInput source="general_purpose" fullWidth choices={CHOICES_DONATION_GENERAL_PURPOSE} />,
  // <SelectInput source="general_purpose_2" fullWidth choices={CHOICES_DONATION_GENERAL_PURPOSE_2} />,
  <NullableBitInput source="receipt" fullWidth />,
  <TextInput source="receipt_title" fullWidth />,
  <SelectInput source="receipt_method" fullWidth choices={CHOICES_DONATION_RECEIPT_METHOD} />,
  <TextInput source="jpg_response_code" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  // <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  // <TextInput source="updatedBy" fullWidth />,
];

const validateType: any[] = [];
const validateInvoiceNumber: any[] = [];
const validateStatus: any[] = [];
const validateAmount: any[] = [];
const validatePersonalTeam: any[] = [];
const validateName: any[] = [];
const validateContactPerson: any[] = [];
const validateSalutarion: any[] = [];
const validateContactPersonTel: any[] = [];
const validateEmail: any[] = [];
const validatePaymentMethod: any[] = [];
const validateCreditCard: any[] = [];
const validatePlanPurpose: any[] = [];
const validateGeneralMethod: any[] = [];
const validateGeneralPurpose: any[] = [];
const validateGeneralPurpose2: any[] = [];
const validateReceipt: any[] = [];
const validateReceiptTitle: any[] = [];
const validateReceiptAddress: any[] = [];
const validateReceiptMethod: any[] = [];


const CHOICES_DONATION_PERSONAL_TEAM_BY_ID = Object.fromEntries(CHOICES_DONATION_PERSONAL_TEAM.map(r => [r.id, r.name]));
const CHOICES_DONATION_PLAN_PURPOSE_BY_ID = Object.fromEntries(CHOICES_DONATION_PLAN_PURPOSE.map(r => [r.id, r.name]));
// const CHOICES_DONATION_GENERAL_METHOD_BY_ID = Object.fromEntries(CHOICES_DONATION_GENERAL_METHOD.map(r => [r.id, r.name]));
const CHOICES_DONATION_GENERAL_PURPOSE_BY_ID = Object.fromEntries(CHOICES_DONATION_GENERAL_PURPOSE.map(r => [r.id, r.name]));
// const CHOICES_DONATION_GENERAL_PURPOSE_2_BY_ID = Object.fromEntries(CHOICES_DONATION_GENERAL_PURPOSE_2.map(r => [r.id, r.name]));
const CHOICES_DONATION_RECEIPT_METHOD_BY_ID = Object.fromEntries(CHOICES_DONATION_RECEIPT_METHOD.map(r => [r.id, r.name]));

const DonationXlsHtmlExporter = <T,>(jsonData: Array<any>, _fetchRelatedRecords: (data: any, field: string, resource: string) => Promise<any>, _dataProvider: DataProvider, resource?: string) => {
  // console.log(jsonData);

  jsonData = jsonData.map((row) => {
    delete row.id;
    delete row.general_method;
    delete row.general_purpose_2;
    delete row.createdBy;
    delete row.updatedBy;
    delete row.type;
    delete row.payment_method;
    delete row.lang;

    if (null !== row.personal_team && CHOICES_DONATION_PERSONAL_TEAM_BY_ID[row.personal_team]) {
      row.personal_team = CHOICES_DONATION_PERSONAL_TEAM_BY_ID[row.personal_team]
    }
    if (null !== row.plan_purpose && CHOICES_DONATION_PLAN_PURPOSE_BY_ID[row.plan_purpose]) {
      row.plan_purpose = CHOICES_DONATION_PLAN_PURPOSE_BY_ID[row.plan_purpose]
    }
    // if (null !== row.general_method && CHOICES_DONATION_GENERAL_METHOD_BY_ID[row.general_method]) {
    //   row.general_method = CHOICES_DONATION_GENERAL_METHOD_BY_ID[row.general_method]
    // }
    if (null !== row.general_purpose && CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[row.general_purpose]) {
      row.general_purpose = CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[row.general_purpose]
    }
    // if (null !== row.general_purpose_2 && CHOICES_DONATION_GENERAL_PURPOSE_2_BY_ID[row.general_purpose_2]) {
    //   row.general_purpose_2 = CHOICES_DONATION_GENERAL_PURPOSE_2_BY_ID[row.general_purpose_2]
    // }
    if (null !== row.receipt_method && CHOICES_DONATION_RECEIPT_METHOD_BY_ID[row.receipt_method]) {
      row.receipt_method = CHOICES_DONATION_RECEIPT_METHOD_BY_ID[row.receipt_method]
    }
    return row;
  });

  // console.log(jsonData);

  return XlsHtmlExporter<Donation>(jsonData, _fetchRelatedRecords, _dataProvider, resource, {
    // cols: ['invoice_number', 'jpg_invoice_number', 'status', 'jpg_response_code', 'amount', 'personal_team', 'name', 'contact_person', 'salutarion', 'address', 'contact_person_tel', 'email', 'credit_card', 'plan_purpose', 'general_purpose', 'receipt', 'receipt_title', 'receipt_address', 'receipt_method', 'created', 'updated']
    cols: [
      'invoice_number', // 'jpg_invoice_number',
      'status', // 'jpg_response_code',
      'amount',
      'monthly_amount',
      'personal_team', 'name', 'contact_person',
      'salutarion',
      // 'address',
      'contact_person_tel',
      'email', 'credit_card',
      'plan_purpose',
      'general_purpose',
      'receipt', 'receipt_title', 'receipt_address', 'receipt_method',
       // 'created', 'updated',
      // 'payment_method',
      'credit_card_number', 'credit_card_expiry', 'credit_card_cvc'
    ]
  });
}

const ExportDecryptButton = () => {
  const dp = useDataProvider();
  const resource = useResourceContext();
  const _fetchRelatedRecords = () => Promise.resolve();
  const jsonData: Array<Donation> = [];
  const { filterValues } = useListContext();

  const handleClick = async () => {
    // console.log('handleClick', filterValues);
    const filtersMwd = _makeFilter('donation', { filter: filterValues }).replace(/filter(\d)=/g, 'filter=');
    const urlExport = `${BASE_URL}api/encrypt-value-export/${process.env.REACT_APP_API_TABLE_PREFIX}${'donation'}?${filtersMwd}`;
    const fetched = await fetchJson(urlExport);
    // console.log(fetched)
    const jsonData = fetched.json.map((row: any) => {
      delete row.id;
      delete row.general_method;
      delete row.general_purpose_2;
      delete row.createdBy;
      delete row.updatedBy;
      // delete row.type;
      // delete row.payment_method;
      delete row.lang;

      if (null !== row.personal_team && CHOICES_DONATION_PERSONAL_TEAM_BY_ID[row.personal_team]) {
        row.personal_team = CHOICES_DONATION_PERSONAL_TEAM_BY_ID[row.personal_team]
      }
      if (null !== row.plan_purpose && CHOICES_DONATION_PLAN_PURPOSE_BY_ID[row.plan_purpose]) {
        row.plan_purpose = CHOICES_DONATION_PLAN_PURPOSE_BY_ID[row.plan_purpose]
      }
      // if (null !== row.general_method && CHOICES_DONATION_GENERAL_METHOD_BY_ID[row.general_method]) {
      //   row.general_method = CHOICES_DONATION_GENERAL_METHOD_BY_ID[row.general_method]
      // }
      if (null !== row.general_purpose && CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[row.general_purpose]) {
        row.general_purpose = CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[row.general_purpose];
      }
      // console.log('before - ', row);
      if ('bcu' === row.type) {
        row.general_purpose = CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[2];
      } else if ('scs' === row.type) {
        row.general_purpose = CHOICES_DONATION_GENERAL_PURPOSE_BY_ID[12];
      }
      // console.log('after - ', row);
      // if (null !== row.general_purpose_2 && CHOICES_DONATION_GENERAL_PURPOSE_2_BY_ID[row.general_purpose_2]) {
      //   row.general_purpose_2 = CHOICES_DONATION_GENERAL_PURPOSE_2_BY_ID[row.general_purpose_2]
      // }
      if (null !== row.receipt_method && CHOICES_DONATION_RECEIPT_METHOD_BY_ID[row.receipt_method]) {
        row.receipt_method = CHOICES_DONATION_RECEIPT_METHOD_BY_ID[row.receipt_method]
      }
      return row;
    });

    // const urlClean = `${BASE_URL}api/encrypt-value-clean/${process.env.REACT_APP_API_TABLE_PREFIX}${'donation'}?${filtersMwd}`;
    // await fetchJson(urlClean, { method: 'PUT' });

    XlsHtmlExporter<Donation>(jsonData, _fetchRelatedRecords, dp, resource, {
      cols: [
        'invoice_number', // 'jpg_invoice_number',
        'status', // 'jpg_response_code',
        { field: 'amount', label: 'amount / monthly amount', type: 'number', cb: (row) => 'monthly' === row.status || null === row.amount ? row.monthly_amount : row.amount },
        // 'personal_team',
        'name', 'contact_person',
        'salutarion',
        // 'address',
        'contact_person_tel',
        'email', 'credit_card',
        // 'plan_purpose',
        'general_purpose',
        // 'receipt',
        'receipt_title',
        'receipt_address',
        // 'receipt_method',
        // 'payment_method',
        'credit_card_number', 'credit_card_expiry', 'credit_card_cvc',
        'created', 'updated',
      ]
    });
  }

  return <Button label="Decrypt Export" onClick={handleClick}>
    <NoEncryptionIcon />
  </Button>;
}

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    {/* <ExportButton /> */}
    <ExportDecryptButton />
    <JpgResponseCodeDrawerButton showText={true} />
  </TopToolbar>
);

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} actions={<ListActions />} exporter={DonationXlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.invoice_number} (#${record.id})`}
          secondaryText={record => `${record.type} ${record.amount}`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <TextField source="invoice_number" fullWidth />
            <TextField source="jpg_invoice_number" fullWidth />
            <TextField source="type" fullWidth />
            <NumberField source="amount" fullWidth />
            <NumberField source="monthly_amount" fullWidth />
            {/* <TextField source="personal_team" fullWidth /> */}
            <TextField source="name" fullWidth />
            <TextField source="salutarion" fullWidth />
            <TextField source="payment_method" fullWidth />
            <TextField source="credit_card" fullWidth />
            {/* <TextField source="plan_purpose" fullWidth />
            <TextField source="general_method" fullWidth />
            <TextField source="general_purpose" fullWidth />
            <TextField source="general_purpose_2" fullWidth /> */}
            <BooleanField source="receipt" fullWidth />
            {/* <TextField source="receipt_title" fullWidth /> */}
            {/* <TextField source="receipt_method" fullWidth /> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="type" fullWidth />
        <TextField source="invoice_number" fullWidth />
        <TextField source="status" fullWidth />
        <TextField source="jpg_response_code" fullWidth />
        <NumberField source="amount" fullWidth />
        <TextField source="personal_team" fullWidth />
        <TextField source="name" fullWidth />
        <TextField source="contact_person" fullWidth />
        <TextField source="salutarion" fullWidth />
        <TextField source="contact_person_tel" fullWidth />
        <TextField source="email" fullWidth />
        <TextField source="payment_method" fullWidth />
        <TextField source="credit_card" fullWidth />
        <TextField source="plan_purpose" fullWidth />
        {/* <TextField source="general_method" fullWidth /> */}
        <TextField source="general_purpose" fullWidth />
        {/* <TextField source="general_purpose_2" fullWidth /> */}
        <BooleanField source="receipt" fullWidth />
        <TextField source="receipt_title" fullWidth />
        <TextField source="receipt_method" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><SelectInput source="type" disabled={isEdit} fullWidth choices={CHOICES_DONATION_TYPE} validate={validateType} /></Grid>
          <Grid item xs={6}><TextInput source="invoice_number" disabled={isEdit} fullWidth validate={validateInvoiceNumber} /></Grid>
          <Grid item xs={6}><SelectInput source="status" fullWidth choices={CHOICES_DONATION_GENERAL_STATUS} /></Grid>
          <Grid item xs={6}><JpgResponseCodeInput source="jpg_response_code" disabled={isEdit} fullWidth validate={validateStatus} /></Grid>
          <Grid item xs={6}>
            <FormDataConsumer>{({ formData }) => {
              if ('monthly' === formData.payment_method) {
                return <NumberInput source="monthly_amount" fullWidth validate={validateAmount} />
              } else {
                return <NumberInput source="amount" fullWidth validate={validateAmount} />
              }
            }}
            </FormDataConsumer>
          </Grid>
          <Grid item xs={6}><SelectInput source="personal_team" fullWidth choices={CHOICES_DONATION_PERSONAL_TEAM} validate={validatePersonalTeam} /></Grid>
          <Grid item xs={6}><TextInput source="name" fullWidth validate={validateName} /></Grid>
          <Grid item xs={6}><TextInput source="email" fullWidth validate={validateEmail} /></Grid>
          <Grid item xs={12}><TextInput source="address" fullWidth validate={validateEmail} /></Grid>
          <Grid item xs={4}><SelectInput source="salutarion" fullWidth choices={CHOICES_DONATION_SALUTARION} validate={validateSalutarion} /></Grid>
          <Grid item xs={4}><TextInput source="contact_person" fullWidth validate={validateContactPerson} /></Grid>
          <Grid item xs={4}><TextInput source="contact_person_tel" fullWidth validate={validateContactPersonTel} /></Grid>
          <Grid item xs={6}><SelectInput source="payment_method" fullWidth choices={CHOICES_DONATION_PAYMENT_METHOD} validate={validatePaymentMethod} /></Grid>
          <Grid item xs={6}><TextInput source="credit_card" fullWidth validate={validateCreditCard} /></Grid>
          <Grid item xs={12}>
            <FormDataConsumer>{({ formData }) => {
              if ('plan' === formData.type) {
                return <SelectInput source="plan_purpose" fullWidth choices={CHOICES_DONATION_PLAN_PURPOSE} validate={validatePlanPurpose} />
              } else {
                return <>
                  {/* <SelectInput source="general_method" fullWidth choices={CHOICES_DONATION_GENERAL_METHOD} validate={validateGeneralMethod} /> */}
                  <SelectInput source="general_purpose" fullWidth choices={CHOICES_DONATION_GENERAL_PURPOSE} validate={validateGeneralPurpose} />
                  {/* <SelectInput source="general_purpose_2" fullWidth choices={CHOICES_DONATION_GENERAL_PURPOSE_2} validate={validateGeneralPurpose2} /> */}
                </>
              }
            }}</FormDataConsumer>
          </Grid>
          <Grid item xs={4}><BooleanInput source="receipt" fullWidth validate={validateReceipt} /></Grid>
          <Grid item xs={4}><SelectInput source="receipt_method" fullWidth choices={CHOICES_DONATION_RECEIPT_METHOD} validate={validateReceiptMethod} /></Grid>
          <Grid item xs={4}><TextInput source="receipt_title" fullWidth validate={validateReceiptTitle} /></Grid>
          <Grid item xs={12}><TextInput source="receipt_address" fullWidth validate={validateReceiptAddress} /></Grid>
        </GridWrapper>
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: SavingsIcon,
}

export default Resource;
